// Public-facing widget URLs for TP Agency lead capture.
// All CTA buttons now enter the same lead-form funnel first.
// After submission, the form auto-redirects to the demo calendar.

// Primary entry point — used by every Book a Demo / Contact Us /
// Request Demo / Get Started button.
export const GHL_LEAD_FLOW_URL =
  "https://api.tpagency.co/widget/form/7zTbsGgba3vT7XT20JsM";

// Aliases kept for backwards-compat with existing imports across the app.
// Both point at the same lead-form URL so no consumer needs to change.
export const GHL_CALENDAR_URL = GHL_LEAD_FLOW_URL;
export const GHL_FORM_URL = GHL_LEAD_FLOW_URL;

// Retained for potential future direct calendar deep-linking (not used in UI).
export const GHL_CALENDAR_DIRECT_URL =
  "https://api.tpagency.co/widget/bookings/tp-demo-bookingscalls";
export const GHL_CALENDAR_EMBED_URL =
  "https://api.tpagency.co/widget/booking/ynwggB2pr6ABIODgoVLq";
export const GHL_CALENDAR_ID = "ynwggB2pr6ABIODgoVLq";
export const GHL_FORM_ID = "7zTbsGgba3vT7XT20JsM";

// Standard external-link props for CTA buttons that open widgets in a new tab.
export const externalLinkProps = {
  target: "_blank",
  rel: "noopener noreferrer",
};
